export interface StudentInfo {
  name: string;
  firstName: string;
  lastName: string;
  gender: string;
  age: number;
  userSiteName: string;
}

export interface ScoreDetail {
  average: number;
  standardDeviation: number;
  expectedLow: number;
  expectedHigh: number;
  stretchLow?: number;
  stretchHigh?: number;
}

export interface SectionScores {
  reading: ScoreDetail;
  math: ScoreDetail;
  english?: ScoreDetail; //ACT
  science?: ScoreDetail; //ACT
  writing?: ScoreDetail; //ACT
  writingAndLanguage?: ScoreDetail; //SAT
  combinedReadingWriting?: ScoreDetail; //SAT
}

export interface SectionRecommendation {
  overall?: string;
  reading?: string;
  writingAndLanguage?: string;
  math?: string;
  science?: string;
}

export interface XY {
  x: number;
  y: number;
}

export interface ComplexReasoningChartData {
  AbstractReasoning: XY;
  SpatialPerception: XY;
  VerbalReasoning: XY;
}

export interface ExecutiveFunctionsChartData {
  Attention: XY;
  WorkingMemory: XY;
  FlexibleThinking: XY;
}

export interface MemoryAndSpeedChartData {
  MotorSpeed: XY;
  VerbalMemory: XY;
  VisualMemory: XY;
}

export interface CognitiveSkills {
  complexReasoning: {
    description: string;
    chartData: ComplexReasoningChartData;
  };
  executiveFunctions: {
    description: string;
    chartData: ExecutiveFunctionsChartData;
  };
  memoryAndSpeed: {
    description: string;
    chartData: MemoryAndSpeedChartData;
  };
}

export interface NationalAverages {
  composite: ScoreDetail;
  reading: ScoreDetail;
  english: ScoreDetail;
  math: ScoreDetail;
  science?: ScoreDetail;
  combinedReadingAndWriting?: ScoreDetail;
}

export interface TestPrepReport {
  studentInfo: StudentInfo;
  projectedCompositeScore: ScoreDetail;
  sectionScores: SectionScores;
  sectionRecommendations: SectionRecommendation;
  cognitiveSkills: CognitiveSkills;
  nationalAverages: NationalAverages;
}

export interface ComboScoreDetail {
  score?: number;
  midpoint: number;
  stretchLow?: number;
  stretchHigh?: number;
  equivalentMidpoint: number;
  equivalentStretchLow?: number;
  equivalentStretchHigh?: number;
}

export interface ComboSectionScores {
  act: ComboScoreDetail;
  sat: ComboScoreDetail;
}

export interface ComboSections {
  verbal: ComboSectionScores;
  stem: ComboSectionScores;
  overall: ComboSectionScores;
}

export interface SkillData {
  category: string;
  scoredPercentile: number;
  range: string;
}

export interface ComboSkillDetail {
  name: string;
  percentileRange: SkillData;
}

export interface ComboPrimarySkillScores {
  verbalReasoningAccuracy: ComboSkillDetail;
  act: ComboSkillDetail[];
  sat: ComboSkillDetail[];
}

export interface TestPrepComboReport {
  studentInfo: StudentInfo;
  sectionScores: ComboSections;
  primarySkillScores: ComboPrimarySkillScores;
}

export enum ComboSection {
  OVERALL,
  VERBAL,
  STEM,
}
